<!-- 课程管理 添加 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <CourseForm ref="courseEditData" @onCourseAddChangeSelect="setCourseAddData"></CourseForm>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;" v-loading="loading">
      <el-button style="margin-top: 12px;" type="primary" @click="save">更新</el-button>
    </el-card>
  </div>
</template>
<script>
import { BaseVue } from "@/mixin/index";
import { courseEditInitApi, courseEditSaveApi } from "@/api/module/course/course";
import { CourseForm } from "@/views/module/course/comp/";

export default {
  name: "CourseAdd", // 注意：组件名称为CourseAdd，但似乎是编辑功能
  
  mixins: [BaseVue],
  
  components: {
    CourseForm
  },
  
  data() {
    return {
      title: "",
      teacher: "",
      description: "",
      loading: false,
      status: "",
      id: "",
      sid: "",
      activityType: ""
    };
  },
  
  methods: {
    // 更新 保存数据
    save() {
      // 校验
      if (!this.title) {
        this.$message.error("请填写课程名称！");
        this.loading = false;
        return false;
      }
      
      // 如果需要验证sid，可以取消以下注释
      // if (!this.sid) {
      //   this.$message.error("请选择所属学习班！");
      //   this.loading = false;
      //   return false;
      // }
      
      const data = {
        title: this.title,
        teacher: this.teacher,
        sid: this.sid,
        description: this.description,
        id: this.id,
        type: this.activityType
      };
      
      courseEditSaveApi(data)
        .then(response => {
          this.$message({
            message: "操作成功！",
            type: "success"
          });
          setTimeout(() => {
            this.$router.replace({
              path: "/course/dashboard"
            });
          }, 1500);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // extend 获取子组件数据
    setCourseAddData(e) {
      this.activityType = e.activityType;
      this.title = e.title;
      this.teacher = e.teacher;
      this.description = e.description;
      this.sid = e.sid;
    }
  },
  
  mounted() {
    // 获取页面初始数据
    this.id = this.$route.query.id;
    
    courseEditInitApi(this.id)
      .then(response => {
        this.sid = response.sid;
        this.$refs.courseEditData.initData(response);
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style scoped lang="scss">
.form_box {
  .form_box__item {
    margin-bottom: 15px;
    font-size: 14px;
    color: #303133;
    span {
      margin-right: 50px;
      white-space: nowrap;
    }
    .form_box__item__input {
      margin-left: 0;
    }
  }
}
::v-deep .el-input--suffix .el-input__inner{
  width: 320px;
}
::v-deep .form_box__group__item .form_box__group__item__content{
  width: 320px;
}
</style>

